module.exports = __webpack_public_path__ + "img/sssaludconinfo-responsive.f46e1574.svg";